import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ChangedDocumentService, FormbirdInjectorService } from 'formbird-services';
import { Subscription } from 'rxjs';
import { HttpService } from '../http.service';
import { SclMapGeoService } from '../scl-map-geo.service';
import { MapLibraryName } from '../map-library';
import { SclMapConstantService } from '../scl-map-constant.service';
import { SclUtilMapService } from '../scl-util-map.service';

const sclUtilMapService = new SclUtilMapService();

@Component({
  selector: 'geo-auto-complete',
  templateUrl: './geo-auto-complete.component.html',
  styleUrls: [
    './geo-auto-complete.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class GeoAutocompleteComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() disabled;
  @Input() keyName;
  @Input() autocompleteBox: any = {};
  @Input() geocodeSearchService: any;
  @Input() map: any;
  @Input() EPSG: any; // for openlayers
  @Input() mapFunc: any;
  @Input() componentDefinition: any;
  @Input() isParentReady: any;
  @Input() contextParams: any;
  @Input() pageSize: any;
  @Input() document: any;
  @Input() template: any; // 15295
  @Input() fieldName: any; // 15295
  @Output() getStreetData = new EventEmitter();
  @Output() removeStreetCb = new EventEmitter();
  @Output() lookUpResultCb = new EventEmitter();
  @Output() lookUpErrorCb = new EventEmitter();
  @Output() init: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(MatAutocompleteTrigger, {static: false}) trigger;
  @ViewChild('streetGeo', {static: true}) streetGeo: ElementRef;

  // streetData;
  currentStreetData = '';
  streets: any[] = [];

  isGoogle = false;
  mapGeo;
  isReady;
  checkMapReadyCount = 0;
  subs: Subscription = new Subscription(); // 15295
  currentProviderReverseIndex = 0;
  currentProviderLookUpIndex = 0;
  isDisableAddressEntry = false;

  private broadcastService: any;

  constructor(
    private cdRef: ChangeDetectorRef,
    private httpService: HttpService,
    private changedDocumentService: ChangedDocumentService,
    private formbirdInjectorService: FormbirdInjectorService,
  ) {
    this.broadcastService = this.formbirdInjectorService.get('BroadcastService');

    this.mapGeo = new SclMapGeoService(formbirdInjectorService);
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.isReady) {
      return;
    }
    this.isReady = setInterval(() => {
      if (this.isParentReady === true) {
        console.log('done loading parent component !!!');
        clearInterval(this.isReady);
        this.isReady = null; // reset
        this.initialize();
      } else {
        this.checkMapReadyCount++;
        if (this.checkMapReadyCount > 11) {
          console.log('can\'t init geo-component because parent component can\'t finish loading !!!');
          clearInterval(this.isReady);
          this.isReady = null; // reset
        } else {
          console.log('waiting for parent component finish loading... ');
        }
      }
    }, 100);
  }

  ngOnChanges(changes: any) {
    if (changes.autoCompleteBox) {
      this.autocompleteBox = changes.autoCompleteBox.currentValue;
    }
    if (changes.mapGeo) {
      this.mapGeo = changes.mapGeo.currentValue;
    }
    if (changes.keyName) {
      this.keyName = changes.keyName.currentValue;
    }
    if (changes.disabled) {
      this.disabled = changes.disabled.currentValue;
    }
  }

  getDisplayFn() {
    return (val) => val ? val.street : val;
  }

  lookUp( value ) {
    // console.log('%c lookUp, value = ' + value , 'color:blue');
    this.streets = [];
    this.mapGeo.lookUp( [this.autocompleteBox, value]
      , this.lookUpCb.bind(this)
      , this.lookUpCbErr.bind(this)
      , this.lookUpCbSelectOption.bind(this)
      , this.lookUpCbRemoveStreet.bind(this)
    );
  }
  lookUpCb(results) {
    if (results == null) {
      return;
    }
    this.streets = results.filter(street => {
      street.street.toLowerCase().includes(this.currentStreetData);
      // if(street.id != null){
      return street;
      // }
    });
    // auto focus to show drop down popup
    this.trigger._onChange(''); // auto focus
    this.trigger.openPanel(); // auto focus
    this.cdRef.detectChanges();

    this.lookUpResultCb.emit();
  }
  lookUpCbErr(err) {
    console.log('error = ' + err);
    // NotificationService.error(err);
    this.lookUpErrorCb.emit();
  }
  lookUpCbSelectOption(streetData) {
    if (this.mapGeo != null) {
      this.mapGeo.removeFeatures();
    }
    if (streetData == null) {
      return;
    }
    this.getStreetData.emit(streetData);
    // console.log("scope.streetData = " + JSON.stringify(scope.streetData));
  }
  lookUpCbRemoveStreet() {
    this.removeStreetCb.emit();
  }

  

  initialize() {
    this.currentProviderReverseIndex = 0;
    this.currentProviderLookUpIndex = 0;

    this.isDisableAddressEntry = false;
    if (Array.isArray(this.geocodeSearchService) && this.geocodeSearchService.length > 0) {
      if (this.geocodeSearchService[0].name === MapLibraryName.GOOGLE) {
        this.isGoogle = true;
      } else {
        const obj = sclUtilMapService.checkDisableAddressEntry(this.componentDefinition, this.geocodeSearchService); 
        this.isDisableAddressEntry = obj.disableAddressEntry;
        this.currentProviderLookUpIndex = obj.currentProviderLookUpIndex;
        this.currentProviderReverseIndex = obj.currentProviderReverseIndex;
        
        if (this.isDisableAddressEntry === true) { this.disabled = true; }
      }
      
    }
    if (this.EPSG === 'undefined' || this.EPSG == null) {
      this.EPSG = SclMapConstantService.EPSG_3857;
    }


    this.mapGeo.init(this.geocodeSearchService, this.mapGeo, this.map, this.EPSG
      , {
        keyName: this.keyName,
        assetField: this.componentDefinition,
        httpService: this.httpService,
        mapFunc: this.mapFunc,
        contextParams: this.contextParams,
        lookUpCb: this.lookUpCb.bind(this),
        lookUpCbErr: this.lookUpCbErr.bind(this),
        lookUpCbSelectOption: this.lookUpCbSelectOption.bind(this),
        lookUpCbRemoveStreet: this.lookUpCbRemoveStreet.bind(this),
        pageSize: this.pageSize,
        document: this.document,
        clearStreetSearchTextBox: this.clearStreetSearchTextBox.bind(this),
        isDisableAddressEntry: this.isDisableAddressEntry,
        currentProviderReverseIndex: this.currentProviderReverseIndex,
        currentProviderLookUpIndex: this.currentProviderLookUpIndex
      } );

    this.init.emit({ geoAutoComplete: this });

    // 15295
    this.watchReadOnly();

    const formResetSub = this.broadcastService.on('formReset').subscribe(() => {
      this.clearInputData(null);
      this.cdRef.detectChanges();
    });
  }

  clearInputData(keyName) {
    this.currentStreetData = '';
    this.streets = [];
    this.clearStreetSearchTextBox(keyName);
  }

  removeStreet(keyName) {
    if (this.disabled == true) {
      return;
    }

    this.clearInputData(keyName);
    if (this.mapGeo) {
      this.mapGeo.cbRemoveStreet = this.removeStreetCbFunc.bind(this);
      this.mapGeo.removeStreet();
    }
    this.cdRef.detectChanges();
  }
  removeStreetCbFunc() {
    this.removeStreetCb.emit();
    this.mapGeo.cbRemoveStreet = null; // reset
  }

  // 15295
  watchReadOnly() {
    const compSub = this.changedDocumentService.watchComponentDef(this.fieldName, this.template.documentId).subscribe(componentDefinition => {
      this.disabled = componentDefinition?.enabled === false;
      
      const obj = sclUtilMapService.checkDisableAddressEntry(this.componentDefinition, this.geocodeSearchService); 
      this.isDisableAddressEntry = obj.disableAddressEntry;
      if (this.isDisableAddressEntry === true) { this.disabled = true; }

      this.currentProviderLookUpIndex = obj.currentProviderLookUpIndex;
      this.currentProviderReverseIndex = obj.currentProviderReverseIndex;

      this.mapGeo.currentProviderLookUpIndex = this.currentProviderLookUpIndex;
      this.mapGeo.currentProviderReverseIndex = this.currentProviderReverseIndex;
      this.mapGeo.isDisableAddressEntry = this.isDisableAddressEntry;

      this.mapGeo.updateProviderName();

      this.cdRef.detectChanges();
    });
    this.subs.add(compSub);
  }

  clearStreetSearchTextBox(keyName) {
    let iput = document.getElementById(this.keyName + 'InputAutoComplete') as HTMLInputElement;
    if (keyName) {
      iput = document.getElementById(keyName + 'InputAutoComplete') as HTMLInputElement;
    }
    if (iput) {
      iput.value = '';
    }

    // gg
    let iputGG = document.getElementById(this.keyName + 'autocomplete') as HTMLInputElement;
    if (keyName) {
      iputGG = document.getElementById(keyName + 'autocomplete') as HTMLInputElement;
    }
    if (iputGG) {
      iputGG.value = '';
    }
  }
}
